export default "__VITE_ASSET__2db5efc2__"